import { FC, createContext, useContext, useState } from "react";

interface MobileMenuProviderProps {
  children: React.ReactNode;
}

export const MobileMenuContext = createContext({
  showMenu: false,
  setShowMenu: (_value: boolean) => {},
});

const MobileMenuProvider: FC<MobileMenuProviderProps> = ({ children }) => {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <MobileMenuContext.Provider value={{ showMenu, setShowMenu }}>
      {children}
    </MobileMenuContext.Provider>
  );
};

export function useMobileMenu() {
  const context = useContext(MobileMenuContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
}

export default MobileMenuProvider;
